import { Component, OnInit } from '@angular/core';
import { IEmployee } from 'ng2-org-chart/src/employee';
import { DepartmentService, CompanyService } from 'src/app/shared';
declare var jquery: any;
declare var $: any;
declare var Swal: any;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.css']
})
export class DepartmentComponent implements OnInit { 

departmentList = new Array();
department = {"name":"","description":""};
addForm: FormGroup;
editForm: FormGroup;
submitted_add = false;
submitted_edit = false;
currentDepartmentId;

  constructor(private fb: FormBuilder,
    private departmentService: DepartmentService) { 
    this.addForm = fb.group({
      'name': ['', Validators.required],
      'description': ['']
    });

    this.editForm = fb.group({
      'name': ['', Validators.required],
      'description': [''],
      'id': ['', Validators.required]
    });
  }

  ngOnInit() { 
    this.getAllDepartment();
  }

  getAllDepartment(){
    $("#department_table").DataTable().clear().destroy();
    this.departmentList = [];
    this.departmentService.getDepartment().subscribe(data=>{
      this.departmentList = data;
      setTimeout(() => {
        $('#department_table').DataTable({
        });
      }, 10);
    });
  }

  openAddDepartment(){
    this.addForm.patchValue({
      name: "",
      description: ""
    });
    $('#modal-department-add').modal('show');
  }

  addDepartment(value){
    this.submitted_add = true;
    if(this.addForm.invalid){
      return;
    }
    console.log(value);
    this.departmentService.addDepartment(value).subscribe(data => {
      this.submitted_add = false;
      $('#modal-department-add').modal('hide');
      this.getAllDepartment();
      this.successDialog();
    }, error => {
      $('#modal-department-add').modal('hide');
      this.failDialog(error);
    });
  }

  openEditDepartment(id){
    this.currentDepartmentId = id;
    this.departmentService.getDepartmentById(id).subscribe(data => {
      this.department = data;
      this.editForm.patchValue({
        id: this.department['id'],
        name: this.department['name'],
        description: this.department['description']
      });
      $('#modal-department-edit').modal('show');
    });
  }

  updateDepartment(value){
    this.submitted_edit = true;
    if(this.editForm.invalid){
      return;
    }
    console.log(value);
    this.departmentService.updateDepartment(value.id, value).subscribe(data => {
      this.submitted_edit = false;
      $('#modal-department-edit').modal('hide');
      this.getAllDepartment();
      this.successDialog();
    }, error => {
      $('#modal-department-edit').modal('hide');
      this.failDialog(error);
    });
  }

  openDeleteDepartment(id){
    this.currentDepartmentId = id;
    $('#modal-department-remove').modal('show');
  }

  deleteDepartment(){
    this.departmentService.deleteDepartment(this.currentDepartmentId).subscribe(data => {
      $('#modal-department-remove').modal('hide');
      this.successDialog();
      this.getAllDepartment();
    }, error => {
      $('#modal-department-edit').modal('hide');
      this.failDialog(error);
    });
  }

  successDialog(){
    Swal.fire("ทำรายการสำเร็จ!", "", "success");
  }

  failDialog(msg){
    Swal.fire({
      type: 'error',
      title: 'เกิดข้อผิดพลาด',
      text: msg
    })
  }

}
